<template>
    <el-dialog title="场地费配置" :visible="visible" :show="show" width="40%"     :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px">
            <el-form-item label="到场地名称" class="input" prop="name">
                <!--<el-input-number :controls="false" v-model="ruleForm.name" :step="0.1" autocomplete="off"
                                 placeholder="请输入煤炭税点" style="width:90%"></el-input-number>-->
                <el-select v-model="ruleForm.stationId" style="width:90%" @change="changeStation">
                    <el-option v-for="(item,i) in stationList" :label="item.orgName" :value="item.orgId+''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="含税场地费" class="input" prop="price">
                <el-input-number :controls="false" v-model="ruleForm.price" autocomplete="off"
                                 :placeholder="'请输入含税场地费，当前系统配置场地费税点为'+this.stationPoint" style="width:90%" @change="changeHsPrice"></el-input-number>
            </el-form-item>
            <el-form-item label="不含税场地费" class="input" prop="bhsPrice">
                <el-input-number :controls="false" v-model="ruleForm.bhsPrice" autocomplete="off" readonly
                                 placeholder="请输入不含税场地费" style="width:90%"></el-input-number>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.role = this.$storage.get("role");
                    this.getZdList();
                    this.getBaseCocalConfig();
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                stationList:[],
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    name:'',
                    price:'',
                },
                role:'',
                rules:{
                    name:[{ required: true, message: '请选择场地名称', trigger: 'blur' }],
                    price:[{ required: true, message: '请输入含税场地费', trigger: 'blur' }],
                    bhsPrice:[{ required: true, message: '请输入不场地费', trigger: 'blur' }],
                },
                stationPoint:null,
            }
        },
        methods:{
            getZdList(){
                let userId = this.$storage.get("userId");
                this.$http({
                    url: "/sysUserOrg/getZdListByUserId/"+userId,
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.stationList = data.zdList;
                    }
                });
            },
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`basePriceConfig/`+"saveStationConfig":this.url+`basePriceConfig/`+"updateStationConfig",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            changeHsPrice(){
                if (this.ruleForm.price!='' && this.stationPoint!=null){
                    let price  = this.ruleForm.price / this.stationPoint;
                    this.ruleForm.bhsPrice = price.toFixed(1);
                }
            },
            getBaseCocalConfig(){
                this.$http({
                    url: "baseCocalConfig/list",
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        let arr = data.data;
                        if (arr.length>0){
                            this.stationPoint = arr[0].stationTaxPoint;
                        }
                    }
                });
            },
            changeStation(){
                if (this.ruleForm.stationId!=''){
                    this.stationList.find(item =>{
                        if (item.orgId == this.ruleForm.stationId){
                            this.ruleForm.name = item.orgName;
                        }
                    })
                }
            }

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>